import { DocumentNode, gql } from '@apollo/client';

// Statisches Dokument mit GraphQL-Variablen (keine String-Interpolation mehr).
// countryCode wird am Aufrufer per toUpperCase normalisiert und als Variable
// übergeben.
export const updateCountryMutation: DocumentNode = gql`
  mutation UpdateCountry(
    $id: String!
    $name: String!
    $countryCode: String!
    $logisticTypeId: String!
    $localPartnerEmail: String!
    $tesShipperNumber: String!
    $recipientId: String!
  ) {
    updateCountry(input: {
      id: $id
      name: $name
      countryCode: $countryCode
      logisticTypeId: $logisticTypeId
      localPartnerEmail: $localPartnerEmail
      tesShipperNumber: $tesShipperNumber
      recipientId: $recipientId
    })
    {
      country {
        id,
        name,
        countryCode,
        logisticTypeId,
        localPartnerEmail,
        tesShipperNumber,
        recipientId,
      }
    }
  }
`;
